<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          System Level Banners
          <a href="https://www.notion.so/Banners-765409d6e99f4e61b22e163b4237fc9f" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
        </h3>
        <p class="card-subtitle">List of Default Banners to System.</p>

        <!-- Tabs Section -->
        <div class="tabOptions">
          <button :class="{ active: activeTab === 'mbanner' }" @click="switchTab('mbanner')" color="primary" class="mr-2">Mobile Banners</button>
          <button :class="{ active: activeTab === 'wbanner' }" @click="switchTab('wbanner')" color="primary" class="mr-2">Web Banners</button>
          <button :class="{ active: activeTab === 'sbanner' }" @click="switchTab('sbanner')" color="primary" class="mr-2">Shop Banners</button>
        </div>

        <!-- Tab Content Section -->
        <div v-if="activeTab === 'mbanner'">
          <mbanner />
        </div>
        <div v-if="activeTab === 'wbanner'">
          <webbanner />
        </div>
        <div v-if="activeTab === 'sbanner'">
          <shopbanner />
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import mbanner from "./mBanner.vue";
import webbanner from "./wBanner.vue";
import shopbanner from "./sBanner.vue";

export default {
  name: "banner",
  components: {
    mbanner,
    webbanner,
    shopbanner,
  },
  data() {
    return {
      activeTab: "mbanner",
    };
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
    },
  },
};
</script>

<style scoped>
.tabOptions {
  display: flex;
  font-size: larger;
  font-weight: bolder;
}

.tabOptions button {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 20px;
  cursor: pointer;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.tabOptions button.active {
  border-bottom: 2px solid #007bff; /* Color for the active tab */
  color: #007bff; /* Text color for the active tab */
}

.tabOptions button:hover {
  color: #0056b3; /* Text color on hover */
}

.tabOptions button:focus {
  outline: none; /* Remove default outline on focus */
}
</style>
